import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateModelMutation } from '../../features/fullApi';

export default function EditDialog({openEdit, setOpenEdit, handleUpdateModel, item}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateModel] = useUpdateModelMutation()

    const onSubmit = async(values, actions) => {
          updateModel({_id: item._id, modelName: values.modelName }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: item._id})
          .then(res => {
            console.log("res is")
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          modelName: item?.modelName,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} >
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit Model
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>You are editing {item?.modelName}</DialogContentText>
                    <TextField
                        id="modelName"
                        type="text"
                        margin="dense"
                        value={values.modelName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.modelName ? "" : "Model"}
                    />
                    {errors.modelName && touched.modelName && (
                        <p className="error">{errors.modelName}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateModel({id: item, modelName: values.modelName})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}